import dayjs from "dayjs";

export const getDefaultAsOfDate = (): dayjs.Dayjs => {
    const now = dayjs();
    const twoMonthsAgo = now.subtract(2, "month");
    return twoMonthsAgo.endOf("month");
};
